import { render, staticRenderFns } from "./NewHighlightsSection.vue?vue&type=template&id=bcaaf198&scoped=true"
import script from "./NewHighlightsSection.vue?vue&type=script&lang=ts"
export * from "./NewHighlightsSection.vue?vue&type=script&lang=ts"
import style0 from "./NewHighlightsSection.vue?vue&type=style&index=0&id=bcaaf198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaaf198",
  null
  
)

export default component.exports